import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=272d6c6e&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('272d6c6e')) {
      api.createRecord('272d6c6e', component.options)
    } else {
      api.reload('272d6c6e', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=272d6c6e&", function () {
      api.rerender('272d6c6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lEcC2vEBvGyG/JS/offershelp.vue"
export default component.exports